export default function fetchResidentMedications(fetch, organizationName, residentId) {
  return fetch(
    `/organizations/${organizationName}/residents/${residentId}/medications.json`
  );
}
